import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, isRef as _isRef, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-193dcc46"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "container"
};
var _hoisted_2 = {
  "class": "list"
};
import Activity from '@/common/components/Activity.vue';
import { ScreenScrollView, useScrollView } from '@/common/components/ScreenScroll';
import IndexCardItem from '@/components/IndexCardItem.vue';
import { postApiFeedbackProblemList } from '@/service/api';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _useScrollView = useScrollView({
        initPageSize: 30,
        api: function api(model) {
          return postApiFeedbackProblemList({
            pageIndex: model.pageIndex,
            pageSize: model.pageSize,
            appId: window.appId
          });
        }
      }),
      model = _useScrollView.model,
      list = _useScrollView.list,
      method = _useScrollView.method,
      loading = _useScrollView.loading,
      refreshing = _useScrollView.refreshing,
      error = _useScrollView.error;
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Activity, {
        "class": "QaView",
        fixed: true
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_unref(ScreenScrollView), _mergeProps(_unref(model), {
            list: _unref(list),
            method: _unref(method),
            loading: _unref(loading),
            "onUpdate:loading": _cache[0] || (_cache[0] = function ($event) {
              return _isRef(loading) ? loading.value = $event : null;
            }),
            refreshing: _unref(refreshing),
            "onUpdate:refreshing": _cache[1] || (_cache[1] = function ($event) {
              return _isRef(refreshing) ? refreshing.value = $event : null;
            }),
            error: _unref(error),
            "onUpdate:error": _cache[2] || (_cache[2] = function ($event) {
              return _isRef(error) ? error.value = $event : null;
            })
          }), {
            "default": _withCtx(function () {
              return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list) || [], function (item) {
                return _openBlock(), _createBlock(IndexCardItem, {
                  key: item.id,
                  item: item
                }, null, 8, ["item"]);
              }), 128))])])];
            }),
            _: 1
          }, 16, ["list", "method", "loading", "refreshing", "error"])];
        }),
        _: 1
      });
    };
  }
});